module.exports = __webpack_public_path__ + "img/20200506145210763.079ea15e.png";